// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3CB5E","comment":"styles_comment__2jFDV"};